import { useAuth } from '@/core/auth/client/AuthProvider';

import NavbarPrivate from './navbarPrivate/NavbarPrivate';
import NavbarPublic from './NavbarPublic';

const WrapperNavbar = () => {
  const { session } = useAuth();

  if (!session) {
    return <NavbarPublic />;
  }

  return (
    <NavbarPrivate />
  );
};

export default WrapperNavbar;
